<template>
    <div class="k-navbar-w ">
        <ul class="k-navbar" ref="navbar">
            <li v-for="(item,index) in list" :class="{active:index===value}" @click="selectItem(index,$event)"><a href="javascript:;">{{item}}</a></li>
        </ul>
        <!--:style="{width:navWidth, transform:`translateX(-${navLeft}px)`}"-->
    </div>
</template>

<script>
    export default {
        name: "k-navbar",
        props : ["list","value"],
        data(){
            return  {
                offsetLeft : 0,
                navWidth : '100%',
                navLeft : 0
            }
        },
        model : {
          prop : "value",
          event : "click"
        },
        computed:{
        },
        methods : {
            selectItem(index, event){
                this.$emit("click", index);
                let target = event.target;
                let ew = target.clientWidth;
                this.offsetLeft = target.offsetLeft;
                this.setScroll(ew/2);

                //console.log(target.offsetLeft);
            },
            admateScroll(ew){
                let docB = document.body;
                let bw = docB.clientWidth;
                let uW = this.$refs.navbar.clientWidth;
                if(uW > bw && this.offsetLeft > bw/2){
                    let left = this.offsetLeft - bw/2 + ew;
                    if(left > uW-bw){
                        left = uW-bw
                    }
                    this.navLeft = left

                } else {
                    this.navLeft = 0
                }
                //console.log(bw - this.offsetLeft);
            },
            setScroll(ew){
                let bw = this.$refs.navbar.clientWidth;
                let uW = this.$refs.navbar.scrollWidth;
                if(uW > bw && this.offsetLeft > bw/2){
                    this.$refs.navbar.scrollLeft = this.offsetLeft - bw/2 + ew
                } else {
                    this.$refs.navbar.scrollLeft = 0
                }
                //console.log(bw - this.offsetLeft);
            },
        },
        mounted() {
            setTimeout(()=>{
                this.navWidth = this.$refs.navbar.scrollWidth + 'px';
            },100)
        }
    }
</script>

<style scoped>

</style>